import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { DigitalSignatureServiceStore } from '@app/requests/logalty-digital-signature/digital-signature-service/digital-signature-service.store';

@Component({
  selector: 'app-third-party-saml-search',
  templateUrl: './third-party-saml-search.component.html',
  styleUrls: ['./third-party-saml-search.component.scss'],
})
export class ThirdPartySamlSearchComponent implements OnInit {
  ThirdPartySamlForm: FormGroup;

  constructor(
    private readonly router: Router,
    private readonly digitalSignatureServiceStore: DigitalSignatureServiceStore,
    private readonly formBuilder: FormBuilder
  ) {
    this.ThirdPartySamlForm = this.formBuilder.group({
      saml: ['', [Validators.required]],
    });
  }

  ngOnInit(): void {}

  showIframeLogalty() {
    this.digitalSignatureServiceStore.setSAMLthirdParty(this.ThirdPartySamlForm.value.saml);
    this.router.navigate(['/third-party-saml-signature']);
  }

  ngAfterViewInit() {}
}
